import {PageFragment, PageFragmentProps, PageFragmentState, PageFragmentStyleFlags} from "@/shared/PageFragment";
import {PathComponent} from "@/shared";
import {LabelerDataset, ResourceData} from "../../../fyneai-shared/types";
import React from "react";
import {Outlet} from "react-router-dom";
import {TabInfo} from "../../../shared/TabsContainer";
import {TasksFragment} from "./tasks/TasksFragment";
import {TaskFragment} from "./tasks/TaskFragment";
import {ImportsFragment} from "./imports/ImportsFragment";

export type DatasetFragmentProps = PageFragmentProps & {
  datasetId: string,
  onBack: () => void,
}

type DatasetFragmentState = PageFragmentState & {
  dataset: LabelerDataset,
}

enum TabType {
  TASKS = "tasks",
  IMPORTS = "imports",
}

const TABS: TabInfo<TabType>[] = [
  {
    text: "Tasks",
    type: TabType.TASKS,
  },
  {
    text: "Imports",
    type: TabType.IMPORTS,
  },
];

export class DatasetFragment extends PageFragment<DatasetFragmentProps, DatasetFragmentState> {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: "tasks/:task_id",
        render: pathProps => <TaskFragment path={pathProps} datasetId={pathProps.params.dataset_id} taskId={pathProps.params.task_id} onBack={() => pathProps.navigate("../")} />,
      }
    ];
  }

  protected onCreateState(props?: DatasetFragmentProps): DatasetFragmentState {
    return {
      ...super.onCreateState(props),
      selectedToolbarTabId: TabType.TASKS,
    };
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    await super.fetchOnMount(forceReload);
    const dataset = await ResourceData.project().labeler.datasets.getOrLoadItem(this.props.datasetId);
    this.setState({
      dataset,
      title: dataset?.name,
    })
  }

  getToolbarTabs(): TabInfo<any>[] {
    return TABS;
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_BACK_BUTTON_FLAG | PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  onBackButtonClicked() {
    this.props.onBack();
  }

  protected renderContainerContent(): React.ReactElement | null {
    if (this.props.path.params.task_id || this.props.path.params.import_id) {
      return <Outlet/>;
    }
    return super.renderContainerContent();
  }

  renderContent(): React.ReactElement {
    switch (this.state.selectedToolbarTabId) {
      case TabType.TASKS:
        return <TasksFragment path={this.props.path} datasetId={this.props.datasetId}/>;
      case TabType.IMPORTS:
        return <ImportsFragment path={this.props.path} datasetId={this.props.datasetId}/>;
    }
    return null;
  }
}